const CONGRESS_USER_TOKEN = "congress-user-token";

export const getUserToken = () => localStorage.getItem(CONGRESS_USER_TOKEN);
export const setUserToken = (token: string) =>
  localStorage.setItem(CONGRESS_USER_TOKEN, token);
export const removeUserToken = () =>
  localStorage.removeItem(CONGRESS_USER_TOKEN);
